import { __rest } from "tslib";
import React, { useCallback, forwardRef } from 'react';
import { generateId } from '../../utils/generateId';
import { Input, Textarea } from './styled';
import { ComponentSize } from '../types';
const NUMBER_REGEX = /^-?[0-9]*\.?[0-9]+$/;
export const TextField = forwardRef((_a, ref) => {
    var { id, className, disabled = false, hasError, max, min, multiline = false, name, onChange, pattern, placeholder, rows = '3', size = ComponentSize.base, step, type = 'text', value, spellCheck = false } = _a, otherProps = __rest(_a, ["id", "className", "disabled", "hasError", "max", "min", "multiline", "name", "onChange", "pattern", "placeholder", "rows", "size", "step", "type", "value", "spellCheck"]);
    const handleChange = useCallback((event) => {
        if (!onChange)
            return;
        const newValue = event.currentTarget.value;
        if (newValue === '') {
            onChange(newValue);
            return;
        }
        if (type !== 'number') {
            onChange(newValue);
            return;
        }
        const reg = new RegExp(NUMBER_REGEX);
        if (!reg.test(newValue)) {
            return;
        }
        onChange(newValue);
    }, [onChange, type]);
    const componentId = id !== null && id !== void 0 ? id : generateId('textfield');
    if (type === 'text' && multiline) {
        return (React.createElement(Textarea, Object.assign({ className: className, disabled: disabled, hasError: hasError, id: componentId, name: name, onChange: handleChange, placeholder: placeholder, rows: rows, value: value, spellCheck: spellCheck, ref: ref }, otherProps)));
    }
    return (React.createElement(Input, Object.assign({ className: className, disabled: disabled, hasError: hasError, id: componentId, inputSize: size, max: max, min: min, name: name, onChange: handleChange, placeholder: placeholder, step: step, type: type, value: value, spellCheck: spellCheck, ref: ref }, otherProps)));
});
//# sourceMappingURL=TextField.js.map